// react
import React, { useEffect, useState } from 'react';
import { TextBox } from 'devextreme-react';

import Indicator from './Indicator';
import http from '../../utils/http';
import { HubConnectionBuilder } from "@microsoft/signalr";
import { Link } from 'react-router-dom';


function Indicators(props) {

    const [connection, setConnection] = useState(null);

    const [notifications, setNotifications] = useState([]);

    const getNotifications = params => http('reports/notifications').asGet().then(r => setNotifications(r));

    useEffect(() => {

        const connect = new HubConnectionBuilder()
            .withUrl("/api/billHubs")
            .withAutomaticReconnect()
            .build();

        setConnection(connect);

    }, [0]);

    useEffect(() => {

        getNotifications();

        if (connection) {
            connection.start()
                .then(() => {
                    connection.on("notifications", resp => {                     
                       
                        getNotifications();

                    });
                })
                .catch((error) => console.log(error));
        }
    }, [connection]);

    const dropdown = 
        <div className="dropcart">
            <div className="dropcart__empty">
                <label className="bill-notify-title">Alertas</label>
                {
                    notifications.length == 0 ? 
                        <div className="dropcart__empty">
                            No se encontraron alertas!
                        </div> 
                    : 
                        <ul className="dropcart__product-options">
                            {notifications.map((noti, index) => (
                                <li key={index} style={{
                                    margin: '5px',
                                    backgroundColor: '#f7f7f7',
                                    borderRadius: '5px',
                                    padding: '5px',
                                    textAlign: 'left'
                                }}>
                                    {
                                        noti.type != 3 &&
                                        <>
                                            <p>{noti.message}</p>
                                            <p>Disponible <b>{noti.to - noti.current}</b>
                                                <Link to="app" className="floatRigth"><span className="dx-icon-preferences"></span>Configurar</Link>
                                            </p>
                                        </>
                                    }
                                    {
                                        noti.type === 3 &&
                                        <>
                                            <p className='text-danger'>{noti.message}</p>
                                            <Link to="/clinica/reportes/stock" className=""><span className="dx-icon-list"></span>Ver lista</Link>
                                        </>
                                    }
                                    
                                </li>
                            ))}
                        </ul>
                }

            </div>
        </div>;


    return (
        <Indicator url="/clinica/bills/expired" dropdown={dropdown} value={notifications.length} icon={<span className="fas fa-globe"></span>} />
    );
}

export default Indicators;
